/*
 * IndusIndTransactionLimits actions
 */
import * as reqHandler from '../../config/services/serviceHandler';
import endpoint from '../../config/endPoints';
import {
  clearDefaultError, rootApiResponse,
} from '../HeaderContainer/actions';
import {
  DEFAULT_ACTION,
  FETCH_TRANSACTIONS_SUCCESS,
  FETCH_CARD_DATA,
  SET_REPORT_SUCCESS_INDUSIND,
} from '../NetworkCards/constants';
import { utils } from '../../devUtils';
import { errorResponse, successResponse } from '../../devUtils/commonUtils';

const fetchCardDataSuccess = (payload) => ({ type: FETCH_CARD_DATA, payload });
const fetchTransactionsSuccess = (payload) => ({ type: FETCH_TRANSACTIONS_SUCCESS, payload });
const reportGenerateSuccess = (payload) => ({ type: SET_REPORT_SUCCESS_INDUSIND, payload });

const fetchCardData = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const res = await reqHandler.postHandler(api, endpoint.GET_YSC_CARD_DETAIL, payload, authPrerequist);
    return dispatch(fetchCardDataSuccess(res));
  } catch (err) {
    dispatch(fetchCardDataSuccess({ status: false }));
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

const fetchTransactions = (payload, otherParams = {}) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    let response = { status: false };
    response = await reqHandler.postHandler(api, endpoint.GET_YSC_CARD_TRANSACTIONS, { ...payload, ...otherParams }, authPrerequist);
    dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
    return dispatch(fetchTransactionsSuccess({ ...response, ts: Date.now() }));
  } catch (err) {
    return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
  }
};

const reportGenerate = (payload, otherParams = {}) => async (dispatch, getState, api) => {
  const { pdf = '' } = otherParams || {};
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    if (!pdf) {
      const response = await reqHandler.postHandler(api, endpoint.POST_CARD_STATEMENT, { ...payload, ...otherParams }, authPrerequist);
      dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
      return dispatch(reportGenerateSuccess(response));
    }
    return dispatch(reportGenerateSuccess({ status: false, pdf }));
  } catch (err) {
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
    return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
  }
};

export { fetchCardData, fetchTransactions, reportGenerate };



// WEBPACK FOOTER //
// client/containers/IndusIndRequestStatement/actions.js